import { Button, CircularProgress, Tooltip } from '@mui/material'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import CustomizedDialogs from 'src/common/components/CustomDialog'
import customToastWithAlert from 'src/common/components/CustomToastWithAlert'
import Spacer from 'src/common/components/Spacer'
import UserAvatar from 'src/common/components/UserAvatar'
import EmptyVulnerabilityDetails from './EmptyVulnerabilityDetails'
import { RefreshOutlined } from '@mui/icons-material'
import threatsService from 'src/services/threats.service'
import InfoDialog from 'src/common/components/InfoDialog'

const STATUSES = {
  SAFE: 'SAFE',
  IN_PROGRESS: 'IN_PROGRESS',
  SUSPICIOUS: 'SUSPICIOUS',
  NOT_ANALYZED: 'NOT_ANALYZED'
}
const STATUS_TITLE = {
  SAFE: 'Safe',
  IN_PROGRESS: 'In Progress',
  SUSPICIOUS: 'Suspicious',
  NOT_ANALYZED: 'Not Analyzed'
}

const VulnerabilityReportStatus = ({ status }) => {
  switch (status) {
    case STATUSES.SAFE:
      return (
        <div style={{ width: '40%', margin: '0px 10px' }}>
          <p style={{ color: '#00ba97' }}>{STATUS_TITLE[status]}</p>
        </div>
      )
    case STATUSES.IN_PROGRESS:
      return (
        <div style={{ width: '40%', margin: '0px 10px' }}>
          <p style={{ color: '#6123FF' }}>{STATUS_TITLE[status]}</p>
        </div>
      )
    case STATUSES.SUSPICIOUS:
      return (
        <div style={{ width: '40%', margin: '0px 10px' }}>
          <p style={{ color: '#E3A202' }}>{STATUS_TITLE[status]}</p>
        </div>
      )
    case STATUSES.NOT_ANALYZED:
      return (
        <div style={{ width: '40%', margin: '0px 10px' }}>
          <p>{STATUS_TITLE[status]}</p>
        </div>
      )
  }
}
const VulnerabilityReportIcon = ({ type }) => {
  switch (type) {
    case 'LINK':
      return (
        <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path d='M14 10L10 14' stroke='#33363F' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
          <path
            d='M16 13L18 11C19.3807 9.61929 19.3807 7.38071 18 6V6C16.6193 4.61929 14.3807 4.61929 13 6L11 8M8 11L6 13C4.61929 14.3807 4.61929 16.6193 6 18V18C7.38071 19.3807 9.61929 19.3807 11 18L13 16'
            stroke='#33363F'
            strokeWidth='2'
            strokeLinecap='round'
          />
        </svg>
      )
    case 'ATTACHMENT':
      return (
        <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path d='M9 13L15 13' stroke='#33363F' strokeWidth='2' strokeLinecap='round' />
          <path d='M9 9L13 9' stroke='#33363F' strokeWidth='2' strokeLinecap='round' />
          <path d='M9 17L13 17' stroke='#33363F' strokeWidth='2' strokeLinecap='round' />
          <path
            d='M19 13V15C19 17.8284 19 19.2426 18.1213 20.1213C17.2426 21 15.8284 21 13 21H11C8.17157 21 6.75736 21 5.87868 20.1213C5 19.2426 5 17.8284 5 15V9C5 6.17157 5 4.75736 5.87868 3.87868C6.75736 3 8.17157 3 11 3V3'
            stroke='#33363F'
            strokeWidth='2'
          />
          <path d='M18 3L18 9' stroke='#33363F' strokeWidth='2' strokeLinecap='round' />
          <path d='M21 6L15 6' stroke='#33363F' strokeWidth='2' strokeLinecap='round' />
        </svg>
      )
    case 'COPIED':
      return (
        <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M8.00009 13L12.2278 16.3821C12.6557 16.7245 13.2794 16.6586 13.6264 16.2345L22.0001 6'
            stroke='#00ba97'
            strokeWidth='1.2'
            strokeLinecap='round'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M10.5653 12.3677L15.4644 6.37999C15.6742 6.12352 15.6364 5.7455 15.3799 5.53567C15.1235 5.32583 14.7455 5.36363 14.5356 5.6201L9.6434 11.5995L10.5653 12.3677ZM8.03225 15.4637L7.11035 14.6954L6.14267 15.8782C6.00694 16.044 5.76456 16.0735 5.59309 15.9449L2.36 13.52C2.0949 13.3212 1.71882 13.3749 1.52 13.64C1.32118 13.9051 1.3749 14.2812 1.64 14.48L4.87309 16.9049C5.559 17.4193 6.52849 17.3016 7.07142 16.638L8.03225 15.4637Z'
            fill='#00ba97'
            fillOpacity='0.25'
          />
        </svg>
      )
  }
}

export const VulnerabilityReportButton = ({ item }) => {
  const [modalOpen, setModalOpen] = useState(false)
  const [confirmationOpen, setConfirmationOpen] = useState(false)
  const [copied, setCopied] = useState(null)
  const [isScaning, setIsScaning] = useState(false)
  const [data, setData] = useState(null)

  const handleClose = () => {
    setModalOpen(false)
  }
  const showConfirmation = () => {
    setConfirmationOpen(true)
  }
  const closeConfirmation = () => {
    setConfirmationOpen(false)
  }

  const handleRescan = () => {
    setIsScaning(true)
    threatsService
      .rescan(item.id)
      .then(resp => {
        setData(resp.data)
        customToastWithAlert({
          type: 'success',
          message: resp.data?.length ? 'Rescan done' : 'Rescan done. No vulnerabilities were found'
        })
      })
      .catch(() => {
        customToastWithAlert({
          type: 'error',
          message: 'Something went wrong'
        })
      })
      .finally(() => {
        setIsScaning(false)
        setConfirmationOpen(false)
      })
  }

  useEffect(() => {
    setData(null)
  }, [item])

  const items = data ? data : item?.contents

  const linkItems = items?.filter(item => item.type == 'LINK') || []
  const attachItems = items?.filter(item => item.type == 'ATTACHMENT') || []

  const clickLink = link => {
    navigator.clipboard.writeText(link)
    setCopied(link)
    customToastWithAlert({
      message: 'Link copied to clipboard',
      type: 'success'
    })
  }

  return (
    <>
      <Button onClick={() => setModalOpen(true)} variant={'outlined'} sx={{ ...styles.button }}>
        Vulnerability report
      </Button>

      {modalOpen && (
        <CustomizedDialogs
          headerColor={'#fff'}
          open={modalOpen}
          handleClose={isScaning ? showConfirmation : handleClose}
          title={'Vulnerability report'}
        >
          <div className='reported-by' style={{ marginBottom: '10px', marginTop: '10px' }}>
            <div className='column'>
              <div className='row'>
                <Tooltip title={item?.subject || ''} arrow>
                  <h2 className='threat-details-title text-shrink-1' style={{ marginBottom: 10, maxWidth: 660 }}>
                    Subject: {item?.subject}
                  </h2>
                </Tooltip>
                <Spacer />
                <Button
                  onClick={handleRescan}
                  disabled={isScaning}
                  startIcon={isScaning ? <CircularProgress size={20} sx={{ color: 'inherit' }} /> : <RefreshOutlined />}
                  variant={'outlined'}
                  sx={{ ...styles.button, margin: 0 }}
                >
                  Rescan
                </Button>
              </div>
              <div className='row row-center'>
                <div className='row row-center'>
                  <UserAvatar id={item?.userId} firstName={item?.userFullName} />
                  <div className='column pointer'>
                    <p className='reported-by-title'> {item?.userFullName}</p>

                    <p className='reported-by-description'>
                      Reported by:{' '}
                      <span
                        style={{
                          color: '#274AF2'
                        }}
                      >
                        {item?.to}
                      </span>
                    </p>
                    <p className='reported-by-dateTime' style={{ textAlign: 'left', marginTop: 3 }}>
                      {dayjs.utc(item?.actionAt).local().format('D MMM HH:mm YYYY')}
                    </p>
                  </div>
                </div>
                <Spacer style={{ minWidth: '30px' }} />
              </div>
            </div>
          </div>
          <div
            className='column'
            style={{
              maxHeight: 'calc(95vh - 290px)',
              overflow: 'auto',
              scrollbarWidth: 'thin',
              scrollbarColor: '#DBDBE6 transparent'
            }}
          >
            {(!items || items?.length == 0) && <EmptyVulnerabilityDetails />}

            {linkItems.length !== 0 && (
              <div className='column'>
                <div className='row' style={{ background: '#00000015', borderRadius: 5 }}>
                  <div style={{ width: 'calc(50% + 42px)' }}>
                    <p style={{ fontWeight: 500, padding: '15px 10px' }}>Links</p>
                  </div>
                  <p style={{ fontWeight: 500, padding: '15px 10px' }}>Status</p>
                </div>
                {linkItems.map(el => (
                  <div key={el.id} className='row' style={{ padding: '16px 5px', borderBottom: '1px solid #E7E8EA' }}>
                    {<VulnerabilityReportIcon type={copied && copied == el.name ? 'COPIED' : el.type} />}
                    <div
                      onClick={() => clickLink(el.name)}
                      className='vulnerability-link-container'
                      style={{ width: '50%', margin: '0px 10px', cursor: 'pointer' }}
                    >
                      <Tooltip title={el.name} arrow>
                        <p className='text-shrink-1'>{el.name}</p>
                      </Tooltip>
                    </div>
                    <VulnerabilityReportStatus status={el.status} />
                  </div>
                ))}
              </div>
            )}

            {attachItems.length !== 0 && (
              <div className='column'>
                <div className='row' style={{ background: '#00000015', borderRadius: 5 }}>
                  <div style={{ width: 'calc(50% + 42px)' }}>
                    <p style={{ fontWeight: 500, padding: '15px 10px' }}>Attachments</p>
                  </div>
                  <p style={{ fontWeight: 500, padding: '15px 10px' }}>Status</p>
                </div>
                {attachItems.map(el => (
                  <div key={el.id} className='row' style={{ padding: '16px 5px', borderBottom: '1px solid #E7E8EA' }}>
                    <VulnerabilityReportIcon type={el.type} />
                    <div style={{ width: '50%', margin: '0px 10px' }}>
                      <p className='text-shrink-1'>{el.name}</p>
                    </div>
                    <VulnerabilityReportStatus status={el.status} />
                  </div>
                ))}
              </div>
            )}
          </div>
        </CustomizedDialogs>
      )}

      <InfoDialog
        open={isScaning && confirmationOpen}
        title={'Scanning in progress'}
        description={'Please wait until the scan is complete. This window cannot be closed during the process'}
        onCancel={closeConfirmation}
        onConfirm={closeConfirmation}
      />
    </>
  )
}

const styles = {
  button: {
    fontWeight: 500,
    borderRadius: '8px',
    textTransform: 'none',
    fontSize: '16px',
    color: '#6123FF',
    borderColor: '#6123FF',
    fontFamily: 'Satoshi',
    marginRight: '10px',
    padding: '3px 16px'
  }
}
